export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'msgTemplateName',
    align: 'left',
    minWidth: 200,
    title: '消息模板名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'msgTemplateType',
    align: 'left',
    width: 150,
    title: '消息模板类型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'controlType',
    align: 'left',
    width: 150,
    title: '界面控件类型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'fieldLength',
    align: 'left',
    width: 100,
    title: '字段长度',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'msgTemplateContent',
    align: 'left',
    minWidth: 350,
    title: '消息模板内容',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    align: 'left',
    width: 100,
    title: '状态',
    slots: {
      default: 'status'
    },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'createByName',
    title: '创建人',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'createTime',
    title: '创建时间',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'modifyByName',
    title: '修改人',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  }
]
